import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.is-array.js";
import _extends from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/extends";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import { scrollTo } from "scroll-js";
import Cookies from "js-cookie";
import { create } from "mobx-persist";
import platform from "platform";
import Router from "next/router";
import { easeInOutQuad, getEnvProps, getUniqueId, toInteger, PlatformUtil, hashCode, PlatformType, PushNotificationAuthorizationStatus, CapabilityPermissionStatus, AuthSecurityLevel, AuthType, handle } from "@dp/common";
var DEFAULT_TIMEOUT = 5000;

var asyncTimeout = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(promise) {
    var ms,
        rejectAfterTimeout,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ms = _args.length > 1 && _args[1] !== undefined ? _args[1] : DEFAULT_TIMEOUT;
            rejectAfterTimeout = new Promise(function (resolve, reject) {
              return setTimeout(reject, ms, "timed out");
            });
            return _context.abrupt("return", Promise.race([promise, rejectAfterTimeout]));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function asyncTimeout(_x) {
    return _ref.apply(this, arguments);
  };
}();

var requestAnimFrame = function () {
  if (true) {
    var win = window;
    return window.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || function (callback) {
      window.setTimeout(callback, 1000 / 60);
    };
  }
}();

var WebUtils = /*#__PURE__*/function (_PlatformUtil) {
  _inherits(WebUtils, _PlatformUtil);

  var _super = _createSuper(WebUtils);

  function WebUtils() {
    var _this;

    _classCallCheck(this, WebUtils);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "PLATFORM_TYPE", PlatformType.WEB);

    _defineProperty(_assertThisInitialized(_this), "hydrateUsingSessionStorageIntern", create({
      storage: {
        setItem: function setItem(key, value) {
          return new Promise(function (resolve, reject) {
            try {
              if (key && value && sessionStorage) {
                sessionStorage.setItem(key + getUniqueId(), value);
              }

              resolve(value);
            } catch (e) {
              reject(e);
            }
          });
        },
        getItem: function getItem(key) {
          return new Promise(function (resolve, reject) {
            try {
              if (key && sessionStorage) {
                resolve(sessionStorage.getItem(key + getUniqueId()));
              } else {
                resolve(null);
              }
            } catch (e) {
              reject(e);
            }
          });
        }
      },
      debounce: 500
    }));

    _defineProperty(_assertThisInitialized(_this), "hydrateUsingLocalStorageIntern", create({
      storage: {
        setItem: function setItem(key, value) {
          return new Promise(function (resolve, reject) {
            try {
              if (key && value && localStorage) {
                localStorage.setItem(key + getUniqueId(), value);
              }

              resolve(value);
            } catch (e) {
              reject(e);
            }
          });
        },
        getItem: function getItem(key) {
          return new Promise(function (resolve, reject) {
            try {
              if (key && localStorage) {
                resolve(localStorage.getItem(key + getUniqueId()));
              } else {
                resolve(null);
              }
            } catch (e) {
              reject(e);
            }
          });
        }
      },
      debounce: 500
    }));

    return _this;
  }

  _createClass(WebUtils, [{
    key: "getForegroundLocationPermissions",
    value: function () {
      var _getForegroundLocationPermissions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var navPermissions, locationPermission, permission;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                navPermissions = navigator.permissions;
                locationPermission = {
                  scope: null,
                  accuracy: null,
                  granted: false,
                  expires: null,
                  canAskAgain: false,
                  status: null
                };

                if (!navPermissions) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 5;
                return navPermissions.query({
                  name: "geolocation"
                });

              case 5:
                permission = _context2.sent;
                locationPermission.granted = permission.state === "granted";

              case 7:
                return _context2.abrupt("return", locationPermission);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getForegroundLocationPermissions() {
        return _getForegroundLocationPermissions.apply(this, arguments);
      }

      return getForegroundLocationPermissions;
    }()
  }, {
    key: "requestBackgroundLocationPermission",
    value: function () {
      var _requestBackgroundLocationPermission = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(title, message) {
        var locationPermission;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                locationPermission = {
                  scope: null,
                  accuracy: null,
                  granted: false,
                  expires: null,
                  canAskAgain: false,
                  status: null
                };
                return _context3.abrupt("return", Promise.resolve(locationPermission));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function requestBackgroundLocationPermission(_x2, _x3) {
        return _requestBackgroundLocationPermission.apply(this, arguments);
      }

      return requestBackgroundLocationPermission;
    }()
  }, {
    key: "requestPushNotificationsPermission",
    value: function () {
      var _requestPushNotificationsPermission = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", Promise.resolve(PushNotificationAuthorizationStatus.DENIED));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function requestPushNotificationsPermission() {
        return _requestPushNotificationsPermission.apply(this, arguments);
      }

      return requestPushNotificationsPermission;
    }()
  }, {
    key: "getPushNotificationsPermissions",
    value: function () {
      var _getPushNotificationsPermissions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", Promise.resolve(PushNotificationAuthorizationStatus.NOT_DETERMINED));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function getPushNotificationsPermissions() {
        return _getPushNotificationsPermissions.apply(this, arguments);
      }

      return getPushNotificationsPermissions;
    }()
  }, {
    key: "requestPhotoLibraryPermission",
    value: function () {
      var _requestPhotoLibraryPermission = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", Promise.resolve(CapabilityPermissionStatus.UNAVAILABLE));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function requestPhotoLibraryPermission() {
        return _requestPhotoLibraryPermission.apply(this, arguments);
      }

      return requestPhotoLibraryPermission;
    }()
  }, {
    key: "requestBiometricPermission",
    value: function () {
      var _requestBiometricPermission = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", Promise.resolve(CapabilityPermissionStatus.UNAVAILABLE));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function requestBiometricPermission() {
        return _requestBiometricPermission.apply(this, arguments);
      }

      return requestBiometricPermission;
    }()
  }, {
    key: "getPhotoLibraryPermissions",
    value: function getPhotoLibraryPermissions() {
      return Promise.resolve(CapabilityPermissionStatus.UNAVAILABLE);
    }
  }, {
    key: "getBackgroundLocationPermissions",
    value: function () {
      var _getBackgroundLocationPermissions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var locationPermission;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                locationPermission = {
                  scope: null,
                  accuracy: null,
                  granted: false,
                  expires: null,
                  canAskAgain: false,
                  status: null
                };
                return _context8.abrupt("return", locationPermission);

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function getBackgroundLocationPermissions() {
        return _getBackgroundLocationPermissions.apply(this, arguments);
      }

      return getBackgroundLocationPermissions;
    }()
  }, {
    key: "hasLocationServicesEnabled",
    value: function () {
      var _hasLocationServicesEnabled = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var navPermissions, permission;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                navPermissions = navigator.permissions;

                if (!navPermissions) {
                  _context9.next = 8;
                  break;
                }

                _context9.next = 4;
                return navPermissions.query({
                  name: "geolocation"
                });

              case 4:
                permission = _context9.sent;
                return _context9.abrupt("return", permission.state === "granted");

              case 8:
                return _context9.abrupt("return", false);

              case 9:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function hasLocationServicesEnabled() {
        return _hasLocationServicesEnabled.apply(this, arguments);
      }

      return hasLocationServicesEnabled;
    }()
  }, {
    key: "setCurrentRoute",
    value: function setCurrentRoute(val) {}
  }, {
    key: "determineDeviceAuthSupport",
    value: function () {
      var _determineDeviceAuthSupport = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", Promise.resolve({
                  hasHardWare: false,
                  isEnrolled: false,
                  supportedAuthType: AuthType.NONE,
                  securityLevel: AuthSecurityLevel.NONE
                }));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function determineDeviceAuthSupport() {
        return _determineDeviceAuthSupport.apply(this, arguments);
      }

      return determineDeviceAuthSupport;
    }()
  }, {
    key: "getCurrentGeoCoords",
    value: function () {
      var _getCurrentGeoCoords = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var enableHighAccuracy,
            timeout,
            maximumAge,
            geoLocPromise,
            _yield$handle,
            _yield$handle2,
            location,
            _args11 = arguments;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                enableHighAccuracy = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : false;
                timeout = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : 60000;
                maximumAge = _args11.length > 2 && _args11[2] !== undefined ? _args11[2] : 30 * 60 * 1000;
                geoLocPromise = new Promise(function (resolve, reject) {
                  navigator.geolocation.getCurrentPosition(function (position) {
                    resolve(position);
                  }, function (error) {
                    reject(error);
                  }, {
                    maximumAge: maximumAge,
                    timeout: timeout,
                    enableHighAccuracy: enableHighAccuracy
                  });
                });
                _context11.next = 6;
                return handle(asyncTimeout(geoLocPromise, timeout));

              case 6:
                _yield$handle = _context11.sent;
                _yield$handle2 = _slicedToArray(_yield$handle, 2);
                location = _yield$handle2[1];
                return _context11.abrupt("return", location);

              case 10:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function getCurrentGeoCoords() {
        return _getCurrentGeoCoords.apply(this, arguments);
      }

      return getCurrentGeoCoords;
    }()
  }, {
    key: "scrollToPosition",
    value: function scrollToPosition(to, callback, duration) {
      function move(amount) {
        if (true) {
          var parentNode = document.body.parentNode;
          document.documentElement.scrollTop = amount;
          parentNode.scrollTop = amount;
          document.body.scrollTop = amount;
        }
      }

      function position() {
        if (true) {
          var parentNode = document.body.parentNode;
          return document.documentElement.scrollTop || parentNode.scrollTop || document.body.scrollTop;
        }
      }

      var start = position();
      var change = to - start;
      var currentTime = 0;
      var increment = 20;
      duration = typeof duration === "undefined" ? 500 : duration;

      var animateScroll = function animateScroll() {
        // increment the time
        currentTime += increment; // find the value with the quadratic in-out easing function

        var val = easeInOutQuad(currentTime, start, change, duration); // move the document.body

        move(val); // do the animation unless its over

        if (currentTime < duration) {
          requestAnimFrame(animateScroll);
        } else {
          if (callback && typeof callback === "function") {
            // the animation is done so lets callback
            callback();
          }
        }
      };

      animateScroll();
    }
  }, {
    key: "scrollToElement",
    value: function scrollToElement(componentRef) {
      var topOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return new Promise(function (resolve) {
        if (componentRef) {
          setTimeout(function () {
            var elemRect = componentRef.getBoundingClientRect();
            var scrollTop = document.documentElement.scrollTop;
            var newScrollTop = scrollTop + elemRect.top - topOffset;
            scrollTo(document.body, {
              top: newScrollTop,
              behavior: "smooth"
            }).then(function () {
              resolve();
            });
          }, 150);
        } else {
          resolve();
        }
      });
    }
  }, {
    key: "saveInSessionStorage",
    value: function saveInSessionStorage(key, val) {
      return new Promise(function (resolve, reject) {
        try {
          if (sessionStorage) {
            if (key) {
              sessionStorage.setItem(key, val);
              resolve();
            } else {
              reject();
            }
          } else {
            reject();
          }
        } catch (e) {
          reject(e);
        }
      });
    }
  }, {
    key: "getFromSessionStorage",
    value: function getFromSessionStorage(key) {
      return new Promise(function (resolve, reject) {
        try {
          if (sessionStorage) {
            if (key) {
              var val = sessionStorage.getItem(key);
              resolve(val);
            } else {
              reject();
            }
          } else {
            reject();
          }
        } catch (e) {
          reject(e);
        }
      });
    }
  }, {
    key: "multiGetFromSessionStorage",
    value: function multiGetFromSessionStorage(keys) {
      return new Promise(function (resolve, reject) {
        try {
          if (sessionStorage) {
            if (keys && keys.length > 0) {
              var results = [];
              keys.forEach(function (key) {
                results.push([key, sessionStorage.getItem(key)]);
              });
              resolve(results);
            } else {
              reject();
            }
          } else {
            reject();
          }
        } catch (e) {
          reject(e);
        }
      });
    }
  }, {
    key: "multiGetFromLocalStorage",
    value: function multiGetFromLocalStorage(keys) {
      return new Promise(function (resolve, reject) {
        try {
          if (localStorage) {
            if (keys && keys.length > 0) {
              var results = [];
              keys.forEach(function (key) {
                results.push([key, localStorage.getItem(key)]);
              });
              resolve(results);
            } else {
              reject();
            }
          } else {
            reject();
          }
        } catch (e) {
          reject(e);
        }
      });
    }
  }, {
    key: "removeFromSessionStorage",
    value: function removeFromSessionStorage(key) {
      return new Promise(function (resolve, reject) {
        try {
          if (sessionStorage) {
            if (key) {
              var val = sessionStorage.removeItem(key);
              resolve();
            } else {
              reject();
            }
          } else {
            reject();
          }
        } catch (e) {
          reject(e);
        }
      });
    }
  }, {
    key: "saveInLocalStorage",
    value: function saveInLocalStorage(key, val) {
      return new Promise(function (resolve, reject) {
        try {
          if (localStorage) {
            if (key) {
              localStorage.setItem(key, val);
              resolve();
            } else {
              reject();
            }
          } else {
            reject();
          }
        } catch (e) {
          reject(e);
        }
      });
    }
  }, {
    key: "getFromLocalStorage",
    value: function getFromLocalStorage(key) {
      return new Promise(function (resolve, reject) {
        try {
          if (localStorage) {
            if (key) {
              var val = localStorage.getItem(key);
              resolve(val);
            } else {
              reject();
            }
          } else {
            reject();
          }
        } catch (e) {
          reject(e);
        }
      });
    }
  }, {
    key: "removeFromLocalStorage",
    value: function removeFromLocalStorage(key) {
      return new Promise(function (resolve, reject) {
        try {
          if (localStorage) {
            if (key) {
              var val = localStorage.removeItem(key);
              resolve();
            } else {
              reject();
            }
          } else {
            reject();
          }
        } catch (e) {
          reject(e);
        }
      });
    }
  }, {
    key: "clearSessionStorage",
    value: function clearSessionStorage(keys) {
      return new Promise(function (resolve, reject) {
        try {
          if (sessionStorage) {
            if (keys && keys.length) {
              keys.forEach(function (key) {
                delete sessionStorage[key];
              });
            } else {
              sessionStorage.clear();
            }

            resolve();
          }
        } catch (e) {
          reject(e);
        }
      });
    }
  }, {
    key: "clearLocalStorage",
    value: function clearLocalStorage(keys) {
      return new Promise(function (resolve, reject) {
        try {
          if (localStorage) {
            if (keys && keys.length) {
              keys.forEach(function (key) {
                delete localStorage[key];
              });
            } else {
              localStorage.clear();
            }
          }

          resolve();
        } catch (e) {
          reject(e);
        }
      });
    }
  }, {
    key: "getLocalStorageKeys",
    value: function getLocalStorageKeys() {
      return Promise.resolve(Object.keys(localStorage));
    }
  }, {
    key: "getSessionStorageKeys",
    value: function getSessionStorageKeys() {
      return Promise.resolve(Object.keys(sessionStorage));
    }
  }, {
    key: "hydrateUsingSessionStorage",
    value: function () {
      var _hydrateUsingSessionStorage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(storeKey, store, initialState) {
        var hydrateFn;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                hydrateFn = this.hydrateUsingSessionStorageIntern;
                return _context12.abrupt("return", hydrateFn(storeKey, store, initialState));

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function hydrateUsingSessionStorage(_x4, _x5, _x6) {
        return _hydrateUsingSessionStorage.apply(this, arguments);
      }

      return hydrateUsingSessionStorage;
    }()
  }, {
    key: "hydrateUsingLocalStorage",
    value: function () {
      var _hydrateUsingLocalStorage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(storeKey, store, initialState) {
        var hydrateFn;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                hydrateFn = this.hydrateUsingLocalStorageIntern;
                return _context13.abrupt("return", hydrateFn(storeKey, store, initialState));

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function hydrateUsingLocalStorage(_x7, _x8, _x9) {
        return _hydrateUsingLocalStorage.apply(this, arguments);
      }

      return hydrateUsingLocalStorage;
    }()
  }, {
    key: "canMakeApplePayPayment",
    value: function canMakeApplePayPayment(merchantIdentifier) {
      var _getEnvProps = getEnvProps(),
          NODE_ENV = _getEnvProps.NODE_ENV,
          NEXT_PUBLIC_REACT_APP_MIN_APPLE_PAY_VERSION = _getEnvProps.NEXT_PUBLIC_REACT_APP_MIN_APPLE_PAY_VERSION;

      return new Promise(function (resolve) {
        var win = window;

        if (win.ApplePaySession && merchantIdentifier) {
          var allowed = sessionStorage.getItem("CAN_MAKE_APPLE_PAY_PAYMENT");

          if (allowed === "true") {
            resolve(true);
          } else {
            var minApplePayVersionSupported = toInteger(NEXT_PUBLIC_REACT_APP_MIN_APPLE_PAY_VERSION, 10);
            var supportsApplePayVersion = ApplePaySession.supportsVersion(minApplePayVersionSupported);

            if (!supportsApplePayVersion) {
              sessionStorage.setItem("CAN_MAKE_APPLE_PAY_PAYMENT", "false");
              resolve(false);
            } else {
              ApplePaySession.canMakePaymentsWithActiveCard(merchantIdentifier).then(function (canMakePaymentsWithActiveCard) {
                if (!canMakePaymentsWithActiveCard) {
                  if (NODE_ENV === "development") {
                    var canMakePayments = ApplePaySession.canMakePayments();
                    sessionStorage.setItem("CAN_MAKE_APPLE_PAY_PAYMENT", canMakePayments ? "true" : "false");
                    resolve(canMakePayments);
                  } else {
                    sessionStorage.setItem("CAN_MAKE_APPLE_PAY_PAYMENT", canMakePaymentsWithActiveCard ? "true" : "false");
                    resolve(canMakePaymentsWithActiveCard);
                  }
                } else {
                  sessionStorage.setItem("CAN_MAKE_APPLE_PAY_PAYMENT", canMakePaymentsWithActiveCard ? "true" : "false");
                  resolve(canMakePaymentsWithActiveCard);
                }
              }, function () {
                sessionStorage.setItem("CAN_MAKE_APPLE_PAY_PAYMENT", "false");
                resolve(false);
              });
            }
          }
        } else {
          resolve(false);
        }
      });
    }
  }, {
    key: "canMakeGooglePayPayment",
    value: function canMakeGooglePayPayment(isReadyToPayRequest) {
      var _getEnvProps2 = getEnvProps(),
          NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV = _getEnvProps2.NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV;

      var DEVELOPMENT = NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV === "development";
      return new Promise(function (resolve) {
        var allowed = sessionStorage.getItem("CAN_MAKE_GOOGLE_PAY_PAYMENT");
        var gPayEnv = sessionStorage.getItem("GOOGLE_PAY_ENV");

        if (allowed === "true") {
          resolve(true);
        } else {
          if (window.google) {
            var _ref2;

            var paymentsClient = new google.payments.api.PaymentsClient({
              environment: (_ref2 = gPayEnv) !== null && _ref2 !== void 0 ? _ref2 : DEVELOPMENT ? "TEST" : "PRODUCTION"
            });
            paymentsClient.isReadyToPay(isReadyToPayRequest).then(function (ret) {
              var result = ret.result;
              var paymentMethodPresent = ret.paymentMethodPresent;
              sessionStorage.setItem("CAN_MAKE_GOOGLE_PAY_PAYMENT", paymentMethodPresent && result ? "true" : "false");
              resolve(paymentMethodPresent && result);
            }, function () {
              sessionStorage.setItem("CAN_MAKE_GOOGLE_PAY_PAYMENT", "false");
              resolve(false);
            });
          } else {
            resolve(false);
          }
        }
      });
    }
  }, {
    key: "loadScript",
    value: function loadScript(url, key, onLoad, urlAttributes) {
      var win = window;
      var uniqId = key ? key : hashCode(url);

      if (!win) {
        return;
      }

      if (!win[uniqId + "_JS"]) {
        if (!Array.from(document.querySelectorAll("script")).some(function (elm) {
          return elm.src === url;
        })) {
          var script = document.createElement("script");
          script.src = url;
          script.type = "text/javascript";

          if (urlAttributes) {
            urlAttributes.forEach(function (val, index) {
              var attr = val.split(":");
              script.setAttribute(attr[0], attr[1]);
            });
          }

          if (onLoad) {
            script.onload = function () {
              onLoad();
            };
          }

          document.getElementsByTagName("head")[0].appendChild(script);
        }

        win[uniqId + "_JS"] = "loaded";
      }
    }
  }, {
    key: "addUrlParam",
    value: function addUrlParam(paramName, paramValue) {
      if (paramName && paramValue && window) {
        var url = new URL(window.location.href);
        url.searchParams["delete"](paramName);
        url.searchParams.set(paramName, paramValue);
        window.history.replaceState(null, null, url.toString());
      }
    }
  }, {
    key: "removeUrlParam",
    value: function removeUrlParam(paramName) {
      if (paramName && window) {
        var url = new URL(window.location.href);
        url.searchParams["delete"](paramName);
        window.history.replaceState(null, null, url.toString());
      }
    }
  }, {
    key: "getBaseDomainURL",
    value: function getBaseDomainURL() {
      var _getEnvProps3 = getEnvProps(),
          NEXT_PUBLIC_REACT_APP_DEV_ENDPOINT_OVERRIDE = _getEnvProps3.NEXT_PUBLIC_REACT_APP_DEV_ENDPOINT_OVERRIDE,
          NODE_ENV = _getEnvProps3.NODE_ENV,
          NEXT_PUBLIC_REACT_APP_PRD_ENDPOINT_OVERRIDE = _getEnvProps3.NEXT_PUBLIC_REACT_APP_PRD_ENDPOINT_OVERRIDE;

      if (NODE_ENV === "development") return NEXT_PUBLIC_REACT_APP_DEV_ENDPOINT_OVERRIDE;else return NEXT_PUBLIC_REACT_APP_PRD_ENDPOINT_OVERRIDE;
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(eventName, action, payload) {
      var eventType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "ACTION";
      var win = window;

      if (win && win.AU) {
        win.AU.dispatchEvent(eventName, action, payload);
      }

      console.log(eventType);
    }
    /*public dispatchAnalyticsEvent(
      action: string,
      payload: { [key: string]: any },
    ): void {
      this.dispatchEvent("AnalyticsEvent", action, payload);
    }
     public dispatchAnalyticsModalEvent(
      modalIntent = "",
      modalContent = "",
      modalName = "",
    ) {
      this.dispatchAnalyticsEvent("DisplayModal", {
        modalIntent,
        modalContent,
        modalName,
      });
    }
    */

  }, {
    key: "getDFPSessionId",
    value: function getDFPSessionId() {
      var win = window;

      if (win && win.dfp) {
        return Promise.resolve(win.dfp.sessionId);
      } else {
        return Promise.resolve(null);
      }
    }
  }, {
    key: "getMarketingCloudId",
    value: function getMarketingCloudId() {
      var win = window;

      if (typeof win !== "undefined" && win._satellite) {
        var marketingCloudVisitorId = win._satellite.getVar("marketingCloudID_global");

        return Promise.resolve(marketingCloudVisitorId);
      } else {
        return null;
      }
    }
  }, {
    key: "redirectToURL",
    value: function redirectToURL(url) {
      if (window) {
        window.location.replace(url);
      }
    }
  }, {
    key: "goToURL",
    value: function goToURL(url) {
      if (window) {
        window.location.href = url;
      }
    }
  }, {
    key: "refreshPage",
    value: function refreshPage() {
      if (window) {
        window.location.reload();
      }
    }
  }, {
    key: "getHostName",
    value: function getHostName() {
      var _window, _window$location;

      return (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname;
    }
  }, {
    key: "getHostProtocol",
    value: function getHostProtocol() {
      var _window2, _window2$location;

      return (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.protocol;
    }
  }, {
    key: "getLocationPathName",
    value: function getLocationPathName() {
      var _window3, _window3$location;

      return (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$location = _window3.location) === null || _window3$location === void 0 ? void 0 : _window3$location.pathname;
    }
  }, {
    key: "getFromSecureStore",
    value: function getFromSecureStore(key, options) {
      console.log("🚀 ~ file: WebUtils.ts ~ line 518 ~ WebUtils ~ getFromSecureStore ~ key", key);
      console.log("🚀 ~ file: WebUtils.ts ~ line 518 ~ WebUtils ~ getFromSecureStore ~ options", options);
      return Promise.resolve(null);
    }
  }, {
    key: "saveInSecureStore",
    value: function saveInSecureStore(key, value, options) {
      console.log("🚀 ~ file: WebUtils.ts ~ line 534 ~ WebUtils ~ key", key);
      console.log("🚀 ~ file: WebUtils.ts ~ line 534 ~ WebUtils ~ value", value);
      console.log("🚀 ~ file: WebUtils.ts ~ line 534 ~ WebUtils ~ options", options);
      return Promise.resolve();
    }
  }, {
    key: "deleteFromSecureStore",
    value: function deleteFromSecureStore(key, options) {
      console.log("🚀 ~ file: WebUtils.ts ~ line 534 ~ WebUtils ~ key", key);
      console.log("🚀 ~ file: WebUtils.ts ~ line 534 ~ WebUtils ~ options", options);
      return Promise.resolve();
    }
  }, {
    key: "isSecureStoreAvailable",
    value: function isSecureStoreAvailable() {
      return Promise.resolve(false);
    }
  }, {
    key: "setCookie",
    value: function setCookie(key, value, domain) {
      Cookies.set(key, value);
      return Promise.resolve();
    }
  }, {
    key: "getCookie",
    value: function getCookie(key, domain) {
      return Promise.resolve(Cookies.get(key));
    }
  }, {
    key: "clearCookie",
    value: function clearCookie(key, domain) {
      Cookies.remove(key);
      return Promise.resolve();
    }
  }, {
    key: "getCookies",
    value: function () {
      var _getCookies = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(domain) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt("return", Promise.resolve({}));

              case 1:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      function getCookies(_x10) {
        return _getCookies.apply(this, arguments);
      }

      return getCookies;
    }()
  }, {
    key: "listCookies",
    value: function listCookies() {
      var result = Cookies.get();
      console.log(result);
      return Promise.resolve();
    }
  }, {
    key: "platformDetails",
    value: function platformDetails() {
      var _platform$os, _platform$os$family, _platform$os2, _platform$os2$family, _platform$os3, _platform$os3$family, _platform$os4, _platform$os4$family, _platform$os5, _platform$os5$family;

      var platformDetails = {
        os: "other",
        isMobile: false,
        name: "other",
        description: ""
      };
      platformDetails.description = (platform === null || platform === void 0 ? void 0 : platform.description) || "";

      if (platform !== null && platform !== void 0 && (_platform$os = platform.os) !== null && _platform$os !== void 0 && (_platform$os$family = _platform$os.family) !== null && _platform$os$family !== void 0 && _platform$os$family.includes("iOS")) {
        platformDetails.os = "iOS";
        platformDetails.isMobile = true;
        platformDetails.name = platform === null || platform === void 0 ? void 0 : platform.name;
      } else if (platform !== null && platform !== void 0 && (_platform$os2 = platform.os) !== null && _platform$os2 !== void 0 && (_platform$os2$family = _platform$os2.family) !== null && _platform$os2$family !== void 0 && _platform$os2$family.includes("OS X") || platform !== null && platform !== void 0 && (_platform$os3 = platform.os) !== null && _platform$os3 !== void 0 && (_platform$os3$family = _platform$os3.family) !== null && _platform$os3$family !== void 0 && _platform$os3$family.includes("Mac")) {
        platformDetails.os = "MacOS";
        platformDetails.name = platform === null || platform === void 0 ? void 0 : platform.name;
      } else if (platform !== null && platform !== void 0 && (_platform$os4 = platform.os) !== null && _platform$os4 !== void 0 && (_platform$os4$family = _platform$os4.family) !== null && _platform$os4$family !== void 0 && _platform$os4$family.includes("Android")) {
        platformDetails.os = "Android";
        platformDetails.isMobile = true;
        platformDetails.name = platform === null || platform === void 0 ? void 0 : platform.name;
      } else if (platform !== null && platform !== void 0 && (_platform$os5 = platform.os) !== null && _platform$os5 !== void 0 && (_platform$os5$family = _platform$os5.family) !== null && _platform$os5$family !== void 0 && _platform$os5$family.includes("Win")) {
        platformDetails.os = "Windows";
        platformDetails.name = platform === null || platform === void 0 ? void 0 : platform.name;
      }

      return platformDetails;
    }
  }, {
    key: "clearCookies",
    value: function () {
      var _clearCookies = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(keys, domain) {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                return _context15.abrupt("return", Promise.resolve());

              case 1:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      function clearCookies(_x11, _x12) {
        return _clearCookies.apply(this, arguments);
      }

      return clearCookies;
    }()
  }, {
    key: "navigateToRoute",
    value: function navigateToRoute(to, routeParams) {
      Router.push(to);
    }
  }, {
    key: "goBack",
    value: function goBack() {// this is an intentional comment to avoid Sonarlint issue
    }
  }, {
    key: "navReload",
    value: function navReload() {
      Router.reload();
    }
  }, {
    key: "navHistory",
    value: function navHistory() {
      return history;
    }
  }, {
    key: "isFreshInstall",
    value: function () {
      var _isFreshInstall = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                return _context16.abrupt("return", Promise.resolve(false));

              case 1:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }));

      function isFreshInstall() {
        return _isFreshInstall.apply(this, arguments);
      }

      return isFreshInstall;
    }()
  }, {
    key: "setFreshInstall",
    value: function () {
      var _setFreshInstall = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(val) {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                Promise.resolve();

              case 1:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }));

      function setFreshInstall(_x13) {
        return _setFreshInstall.apply(this, arguments);
      }

      return setFreshInstall;
    }()
  }, {
    key: "setNavigationProp",
    value: function setNavigationProp(navigation) {
      return;
    }
  }, {
    key: "stopGeoFence",
    value: function stopGeoFence() {
      return Promise.resolve();
    }
  }, {
    key: "isGeoFenceStarted",
    value: function isGeoFenceStarted() {
      return Promise.resolve(false);
    }
  }, {
    key: "isGeoFenceCapable",
    value: function isGeoFenceCapable() {
      return Promise.resolve(false);
    }
  }, {
    key: "startGeoFence",
    value: function startGeoFence(geoFence) {
      return Promise.resolve();
    }
  }, {
    key: "showLocalNotification",
    value: function showLocalNotification(notification) {
      return;
    }
  }, {
    key: "scheduleLocalNotification",
    value: function () {
      var _scheduleLocalNotification = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(notification, triggerTimeStamp) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                return _context18.abrupt("return", null);

              case 1:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));

      function scheduleLocalNotification(_x14, _x15) {
        return _scheduleLocalNotification.apply(this, arguments);
      }

      return scheduleLocalNotification;
    }()
  }, {
    key: "cancelScheduledNotification",
    value: function () {
      var _cancelScheduledNotification = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(notificationId) {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                return _context19.abrupt("return");

              case 1:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19);
      }));

      function cancelScheduledNotification(_x16) {
        return _cancelScheduledNotification.apply(this, arguments);
      }

      return cancelScheduledNotification;
    }()
  }, {
    key: "performBiometricAuthentication",
    value: function performBiometricAuthentication() {
      var retryLoop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return Promise.resolve(true);
    }
  }, {
    key: "performApplePay",
    value: function () {
      var _performApplePay = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(merchantIdentifier, applePayPaymentRequest) {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                return _context20.abrupt("return", null);

              case 1:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }));

      function performApplePay(_x17, _x18) {
        return _performApplePay.apply(this, arguments);
      }

      return performApplePay;
    }()
  }, {
    key: "completeApplePay",
    value: function completeApplePay(result) {}
  }, {
    key: "performPayPal",
    value: function () {
      var _performPayPal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(merchantAccountId, paypalPaymentRequest) {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                return _context21.abrupt("return", null);

              case 1:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21);
      }));

      function performPayPal(_x19, _x20) {
        return _performPayPal.apply(this, arguments);
      }

      return performPayPal;
    }()
  }, {
    key: "performGooglePay",
    value: function () {
      var _performGooglePay = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(googlePayPaymentRequest) {
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                return _context22.abrupt("return", null);

              case 1:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22);
      }));

      function performGooglePay(_x21) {
        return _performGooglePay.apply(this, arguments);
      }

      return performGooglePay;
    }()
  }, {
    key: "registerForPushNotifications",
    value: function () {
      var _registerForPushNotifications = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                return _context23.abrupt("return", null);

              case 1:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23);
      }));

      function registerForPushNotifications() {
        return _registerForPushNotifications.apply(this, arguments);
      }

      return registerForPushNotifications;
    }()
  }, {
    key: "encodeHMACSHA256",
    value: function () {
      var _encodeHMACSHA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(payload, secret) {
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                return _context24.abrupt("return", null);

              case 1:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24);
      }));

      function encodeHMACSHA256(_x22, _x23) {
        return _encodeHMACSHA.apply(this, arguments);
      }

      return encodeHMACSHA256;
    }()
  }, {
    key: "getTwilioAccessToken",
    value: function () {
      var _getTwilioAccessToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(identity, appId, sid, secretKey) {
        var expiresInMillis,
            _args25 = arguments;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                expiresInMillis = _args25.length > 4 && _args25[4] !== undefined ? _args25[4] : 50000;
                return _context25.abrupt("return", null);

              case 2:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25);
      }));

      function getTwilioAccessToken(_x24, _x25, _x26, _x27) {
        return _getTwilioAccessToken.apply(this, arguments);
      }

      return getTwilioAccessToken;
    }()
  }, {
    key: "getApplicationVersion",
    value: function getApplicationVersion() {
      var _getEnvProps4 = getEnvProps(),
          NEXT_PUBLIC_REACT_APP_PERSIST_VER = _getEnvProps4.NEXT_PUBLIC_REACT_APP_PERSIST_VER;

      return NEXT_PUBLIC_REACT_APP_PERSIST_VER; //TODO: Change this
    }
  }, {
    key: "showAlert",
    value: function showAlert(title, message) {
      alert(message);
    }
  }, {
    key: "getiOSversion",
    value: function getiOSversion() {
      if (/iP(hone|od|ad)/.test(navigator.platform)) {
        // supports iOS 2.0 and later
        var v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
        return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || "0", 10)];
      } else {
        return null;
      }
    }
  }, {
    key: "navigate",
    value: function navigate(lat, lng) {
      // If it's an iPhone..
      if (navigator.platform.indexOf("iPhone") !== -1 || navigator.platform.indexOf("iPod") !== -1) {
        var ver = this.getiOSversion() || [0];
        var protocol = "http://";

        if (ver[0] >= 6) {
          protocol = "maps://";
        }

        window.location.href = protocol + "maps.apple.com/maps?daddr=" + lat + "," + lng + "&amp;ll=";
      } else {
        window.open("https://maps.google.com?daddr=" + lat + "," + lng + "&amp;ll=");
      }
    }
  }, {
    key: "startTrace",
    value: function () {
      var _startTrace = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(traceName) {
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                return _context26.abrupt("return", Promise.resolve(null));

              case 1:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26);
      }));

      function startTrace(_x28) {
        return _startTrace.apply(this, arguments);
      }

      return startTrace;
    }()
  }, {
    key: "getTrace",
    value: function getTrace(traceName) {
      return null;
    }
  }, {
    key: "stopTrace",
    value: function () {
      var _stopTrace = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(traceName) {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                return _context27.abrupt("return", Promise.resolve(null));

              case 1:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27);
      }));

      function stopTrace(_x29) {
        return _stopTrace.apply(this, arguments);
      }

      return stopTrace;
    }()
  }, {
    key: "getIpAddress",
    value: function getIpAddress() {
      return null;
    }
  }, {
    key: "getDeviceId",
    value: function getDeviceId() {
      return null;
    }
  }, {
    key: "isAndroidOrAuthTypeFingerprint",
    value: function isAndroidOrAuthTypeFingerprint() {
      return null;
    }
  }, {
    key: "isBiometricsEnabled",
    value: function isBiometricsEnabled(cancelAndroidAuthentication) {
      return null;
    }
  }, {
    key: "getFromOldKeyChain",
    value: function getFromOldKeyChain(key) {
      return null;
    }
  }, {
    key: "flattenObjectWithDot",
    value: function flattenObjectWithDot(obj) {
      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var output = {};

      for (var k in obj) {
        var val = obj[k];
        var newKey = prefix ? prefix + "." + k : k;

        if (typeof val === "object") {
          if (Array.isArray(val)) {
            var arrToObj = _extends({}, val);

            var newObj = this.flattenObjectWithDot(arrToObj, newKey);
            output = _objectSpread(_objectSpread({}, output), newObj);
          } else {
            var _newObj = this.flattenObjectWithDot(val, newKey);

            output = _objectSpread(_objectSpread({}, output), _newObj);
          }
        } else {
          output = _objectSpread(_objectSpread({}, output), {}, _defineProperty({}, newKey, val === null || val === void 0 ? void 0 : val.toString()));
        }
      }

      return output;
    }
  }, {
    key: "getDeviceMake",
    value: function getDeviceMake() {
      return platform === null || platform === void 0 ? void 0 : platform.manufacturer;
    }
  }, {
    key: "getDeviceModel",
    value: function getDeviceModel() {
      return platform === null || platform === void 0 ? void 0 : platform.product;
    }
  }, {
    key: "getDeviceOS",
    value: function getDeviceOS() {
      var _platform$os6;

      return platform === null || platform === void 0 ? void 0 : (_platform$os6 = platform.os) === null || _platform$os6 === void 0 ? void 0 : _platform$os6.toString();
    }
  }, {
    key: "initDFP",
    value: function initDFP(dfpTenantId) {
      console.log("WebUtils initDFP");
    }
  }, {
    key: "randomUniqueId",
    value: function randomUniqueId() {
      return null;
    }
  }, {
    key: "canShowNativeLocationPrompt",
    value: function canShowNativeLocationPrompt() {
      return null;
    }
  }, {
    key: "deviceAuth",
    get: function get() {
      return null;
    },
    set: function set(value) {// this is commented out to avoid un-necessary errors
      // throw new Error("Method not implemented.");
    }
  }]);

  return WebUtils;
}(PlatformUtil);

export default new WebUtils();